import type { Directive } from 'vue'

const observeMap = new WeakMap<Element, IntersectionObserver>()

export const vAppear: Directive = {
  mounted(el, binding) {
    el.classList.add('appear-init')
    const threshold = binding.value?.threshold ?? 0.1
    const rootMargin = binding.value?.rootMargin ?? '0px 0px -10% 0px'
    const once = binding.value?.once ?? true

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          el.classList.add('appear-show')
          if (once) observer.unobserve(el)
        }
      })
    }, { threshold, rootMargin })

    observer.observe(el)
    observeMap.set(el, observer)
  },
  unmounted(el) {
    const ob = observeMap.get(el)
    if (ob) ob.disconnect()
  }
}